import { render, staticRenderFns } from "./thoughtDetail.vue?vue&type=template&id=3e828534&scoped=true"
import script from "./thoughtDetail.vue?vue&type=script&lang=js"
export * from "./thoughtDetail.vue?vue&type=script&lang=js"
import style0 from "./thoughtDetail.vue?vue&type=style&index=0&id=3e828534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e828534",
  null
  
)

export default component.exports